var render = function render(){var _vm=this,_c=_vm._self._c;return _c('myPopup',{attrs:{"flag":_vm.isShow},on:{"close":_vm.close}},[_c('div',[_c('div',{staticClass:"mobile-box",style:({ background: 'url(' + _vm.mobileScreen + ') no-repeat' })},[_c('div',{staticClass:"sms-center"},[_c('div',{staticClass:"message-content"},[_c('div',[_c('p',[_vm._v("【"+_vm._s(_vm.cusuffix)+"】"+_vm._s(_vm.content))])])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }